import { Breadcrumbs } from '@components';
import { useScreenSize } from '@hooks';
import Noise from '@pngs/Noise5.png';
import Net from '@pngs/ProfileGraphicBackground.png';
import { userApi } from '@store';
import { Flex, Image, theme, Typography } from '@styles';
import React, { useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';

import { OngoingModule, PointCard } from './components';
import CertificateInfo from './components/CertificateInfo';
import {
  formatDate,
  profilePageLayoutByVariant,
  styles,
} from './ProfilePage.layoutProps';

const ProfilePage = () => {
  const { data, refetch } = userApi.useGetUserQuery();

  const { i18n } = useTranslation();
  const { device, isTabletLG } = useScreenSize();

  const layout = profilePageLayoutByVariant[isMobile ? 'mobile' : device];

  useEffect(() => {
    refetch();
  }, [i18n.language]);

  // eslint-disable-next-line
  console.log('device', device);

  const isTablet = isMobile || isTabletLG; // fix issues with mobile switch to desktop view

  return (
    <Flex backgroundImage={Noise} {...styles.container}>
      <Breadcrumbs containerProps={{ px: layout?.px }} />
      <Flex backgroundImage={Net} {...styles.netBackground} px={layout?.px}>
        <Flex {...layout.contentContainer}>
          <Flex {...layout.userInfo}>
            <Flex
              alt="avatar"
              backgroundImage={data?.data.avatar}
              {...styles.avatar}
              {...layout.avatar}
            />
            <Typography {...layout.username}>@{data?.data.username}</Typography>
          </Flex>
          <PointCard
            content={data?.data.activities_completed}
            title={i18n.t('ProfilePage.ActivitiesCompleted')}
          />
          <PointCard
            content={`${data?.data.final_tests_completed}/${data?.data.total_final_tests_amount}`}
            title={i18n.t('ProfilePage.FinalTestsPassed')}
          />
          <PointCard
            {...(data?.data.rank?.name
              ? {
                  renderCardContent: (
                    <Image
                      alt="Rank"
                      src={data?.data.rank?.image_large}
                      {...styles.rank}
                    />
                  ),
                }
              : {
                  content: i18n.t('ProfilePage.Rank.None'),
                })}
            title={i18n.t('ProfilePage.Rank.Title')}
          />
        </Flex>
        {data?.data.available_certificates?.length > 0 && (
          <>
            <Flex mb={24} mt={isTablet ? 24 : 64} pb={24} pt={24}>
              <Typography
                color={theme.colors.white[100]}
                mr={24}
                variant="MS-regular-s26-lh40"
                whiteSpace="nowrap"
              >
                {i18n.t('ProfilePage.MyCertificates')}
              </Typography>
              <Flex
                backgroundColor={theme.colors.whiteLine}
                height="2px"
                m="auto"
                width="100%"
              />
            </Flex>
            {data?.data.available_certificates.map((el) => (
              <CertificateInfo
                date={formatDate(el?.completed_at)}
                title={el?.title}
              />
            ))}
          </>
        )}
        {data?.data.ongoing_module && (
          <>
            <Flex mb={24} mt={isTablet ? 24 : 64} pb={24} pt={24}>
              <Typography
                color={theme.colors.white[100]}
                mr={24}
                variant="MS-regular-s26-lh40"
                whiteSpace="nowrap"
              >
                {i18n.t('ProfilePage.OngoingModule')}
              </Typography>
              <Flex
                backgroundColor={theme.colors.whiteLine}
                height="2px"
                m="auto"
                width="100%"
              />
            </Flex>
            <OngoingModule ongoingModule={data?.data.ongoing_module} />
          </>
        )}
      </Flex>
    </Flex>
  );
};

export default ProfilePage;
